export default {
    // ash国际化
    ash: {
        noData: '无权限',
        imported: '已导入',
        payCancelEmptyTip: '手续费扣费比率不能为空',
        minCancelEmptyTip: '取消预订离入住天数范围下限不能为空',
        maxCancelEmptyTip: '取消预订离入住天数范围上限不能为空',
        lockTypeEmpty: '锁类型不能为空',
        lockDateEmpty: '锁定日期不能为空',
        effectiveDateEmpty: '起效日期不能为空',
        maxCustomerNumberTip: '客户合住上限只能输入整数',
        minCancelIntegerTip: '取消预订离入住天数范围下限只能输入整数',
        maxCancelIntegerTip: '取消预订离入住天数范围上限只能输入整数',
        payCancelIntegerTip: '手续费扣费比率只能输入整数',
        numCancelIntegerTip: '取消数量只能输入整数',
        canNotAccepttip: '包含非‘待车辆组受理’的订单，不能受理！',
        acceptSuccessTip: '受理成功！',
        canNotNoticetip: '包含非‘排队中’的订单，不能发布通知！',
        leastOneDataTip: '请至少选择1条订单记录！',
        noticeSuccessTip: '发布通知成功！',
        hasCars: '有车',
        noCar: '无车',
        noshowTip: '按照取消规则规定，本次操作将扣除Noshow费{0}{1}，请确认是否继续执行？',
        shuttles: '接送',
        rentingCar: '押车',
        companyVehicleOrder: '公司用车订单',
        travelVehicle: '商旅押车',
        keywordPlaceholder: '订单编号/团组号/出发地',
        selectAll: '全选',
        accept: '受理',
        userDate: '使用日期',
        dosages: '用量',
        duration: '每日用时',
        vehicleAddress: '用车地点',
        importDeadlineDate: '名单导入截止时间',
        importDeadlineDateTip: '请选择名单导入截止时间',
        cancelQty: '取消数量',
        cancelQtyTip: '取消数量 0 - 100',
        orderList: '订单列表',
        orderStatistics: '订单统计',
        expenseDept: '费用归属部门',
        expenseItem: '费用归属项目',
        contactPhone: '联系手机',
        contactEmail: '联系邮箱',
        localPhone: '本地号码',
        cancelRuleDesc: '取消规则说明',
        carNumEveryDay: '每日用车数量',
        carStartTime: '用车开始时间',
        carEndTime: '用车结束时间',
        carTimeEveryDay: '每日押车时长',
        carStartAddress: '用车开始地点',
        modifyLogs: '修改日志',
        modifyBy: '修改人',
        modifyDate: '更改日期',
        modifyInfoBefore: '修改前信息',
        modifyInfoAfter: '修改后信息',
        allotsRoomTypeTip: '系统{0} ~ {1}的新增房量将自动分配至{2}。',
        allots: '分配',
        queuingQuantity: '排队量',
        exportBNOrder: '导出BN订单',
        queTimeOutTip: '排队预订的截止时间已过，不能再进行预订。',
        vehiclesPhoneTips: '请确认联系人手机号可以用于接收短信。',
        vehiclesPhonePlaceholder: '填入的是联系人手机电话',
        plsOrderStatus: '请选择订单状态',
        bookPerson: '预订人',
        plsGroupNO: '请输入团组编号',
        roomsLeft: '剩{0}间',
        cancelFinesTips: '当前时段取消订单，将收取{0}{1}，请确认是否取消？',
        exportOrder: '导出订单',
        allExhi: '全部展会',
        recentExhi: '近期展会',
        pastExhi: '往期展会',
        searchExhi: '请输入展会名称、举办国家或城市',
        expand: '展开',
        contraction: '收起',
        noPermission: '您没有权限访问操作！',
        noPerTips: '抱歉！您暂时无权限访问该资源，请确定您是否登录,或回到首页选择其他资源。',
        searchHotel: '搜索酒店',
        priceTip: '价格区间起始价格不能大于结束价格',
        queuing: '排队',
        roomLackTip: '{0}房型，在{1}天只剩余{2}余量，请重新输入',
        delRoomTip: '此操作将删除【{0}】房型, 是否继续？',
        delHotelTip: '此操作将删除【{0}】酒店, 是否继续？',
        viewBigMap: '查看大地图',
        followSroll: '跟随浮动',
        food: '美食',
        phoneNumber: '电话',
        address: '地址',
        traffic: '交通',
        attractions: '景点',
        shopping: '购物',
        entertainment: '娱乐',
        carrental: '租车',
        clear: '清除',
        addCustom: '添加自定义',
        getDistance: '距离计算',
        helpTip1: '第一步，选择支付宝支付，点击下一步之后，浏览器地址栏会显示拦截提示图标，如下图红圈所示',
        helpTip2: '第二步，如下图红圈和数字所示',
        helpTip3: '首先，点击拦截提示的图标，显示出一个小对话框',
        helpTip4: '其次，选择“始终允许显示itravel.huawei.com的弹出式窗口”',
        helpTip5: '最后，点击完成提交',
        helpTip6: '第三步，点击浏览器刷新按钮刷新页面，收银台提示窗口消失。选择支付宝支付后，点击下一步按钮',
        helpTip7: '第四步，在打开的新页面中，即可完成支付。',
        personalPayTip: '预付温馨提示:订单办理入住后,如若修改或取消。服务费不予以退还',
        payCost: '支付金额',
        plsPayWay: '请选择支付方式',
        browserTip: '温馨提示:部分浏览器会拦截支付宝弹出窗口，请点击查看如何设置取消浏览器拦截。',
        nextStep: '下一步',
        cashRegister: '收银台',
        dontClose: '请在新打开的页面中完成支付，付款完成前不要关闭此窗口付款',
        doneNext: '完成后，根据您的付款情况点击下面按钮',
        donePay: '完成支付',
        hasProblem: '支付遇到问题',
        wechat: '微信',
        wechatPay: '微信支付',
        alipay: '支付宝',
        ashHotel: '爱上会酒店',
        paySuccess: '支付成功',
        totalCost: '您预订的酒店消费总金额为',
        ssfw: '设施服务',
        cyyl: '餐饮娱乐',
        mfss: '免费设施',
        kfss: '客房设施',
        jdfwss: '酒店服务设施',
        hyss: '会议设施',
        fygkbm: '费用归口部门',
        fygkbmbm: '费用归口部门编码',
        allOrder: '全部订单',
        freeRow: '自由行',
        comments: '条评论',
        specialFares: '特价机票',
        start: '开',
        to: '到',
        dateRangeTip: '请选择入住日期范围',
        noOrderTip: '未查找到订单信息',
        cars: '车辆',
        booking: '预订',
        callNo: '咨询电话',
        bussinessPlaceholder: '请输入订单号/团组编号/酒店名称/项目经理进行查询',
        sendNotify: '发送通知',
        exportFullOrder: '导出全量订单',
        atLeastOne: '请至少选择一个需要发布通知的订单！',
        postNotify: '发布通知',
        queues: '排队情况',
        hasRoom: '有房',
        noRoom: '无房',
        sendTips: '您确定为已选择的订单发送通知, 是否继续?',
        sendSuccess: '发送通知成功!',
        noReturnData: '接口未返回数据',
        cancelTip: '此操作去取消订单编号为{0}的订单, 是否继续？',
        successTip: '恭喜你，订单编号为{0}取消成功！',
        inTheQueue: '排队中',
        queueFailed: '排队失败',
        importPlaceholder: '请输入酒店名称、客户姓名',
        cancelList: '撤销名单',
        import: '导入',
        aaa: '导入模板',
        importBtn: '导 入',
        importTips: '当前订单已经导入{0}间客户信息，还剩{1}间未导入',
        fristName: '姓', // 后台规定firstName为姓
        lastName: '名', // 后台规定lastName为名
        checkinTine: '入住时间',
        checkoutTime: '退房时间',
        resident: '合住人',
        represent: '代表处',
        representEmptyTip: '代表处不能为空',
        groupLevel: '团组级别',
        customerUnits: '客户单位',
        industry: '行业',
        escorts: '陪同人员',
        escortsTel: '陪同人员电话',
        copyman: '抄送人',
        confirmTips: '确认是否撤销选中名单？',
        undoSuccess: '撤销成功',
        undoFailure: '撤销失败',
        undoTips: '请至少选择一条撤销名单',
        updateTip: '上传图片大小不能超过{0}MB!',
        updateSizesTip: '上传图片大小应该在{0}-{1}kB之间！',
        imgFormatTip: '上传图片格式应该为{0}！',
        roomUseInfo: '房间使用情况',
        payWay1: '个人在线支付',
        payWay2: '个人IVR支付（OP）',
        payWay3: '外部月结',
        payWay4: '酒店到店付款',
        cancelOrderTips: '您的订单取消请求已受理，稍后客服会进行处理！',
        hotelCollections: '酒店收藏',
        emailTips: '此邮箱用于接收预订信息，请您正确维护，仔细核对',
        emailCheck: '请输入0开头长度为3-4位的数字',
        telCheck: '请输入7~8位数字',
        extensionCheck: '请输入1~6位数字',
        editContacts: '编辑联系人',
        addContacts: '新增联系人',
        editInvoices: '编辑常用发票',
        addInvoices: '新增常用发票',
        invoicesCategory: '发票类别',
        invoicesHeaderUp: '发票抬头',
        taxpayerIdentificationNum: '纳税人识别号',
        numberBit: '15/18/20位',
        registeredAddress: '注册地址',
        bank: '开户银行',
        account: '账户',
        plsRightBankNo: '请输入正确的银行账号',
        modify: '修改',
        delAddressTip: '是否确认删除【{0}】常用地址？',
        delContactTip: '是否确认删除联系人【{0}】？',
        delInvoiceTip: '是否确认删除【{0}】常用发票？',
        modifyNameTip: '请严格按照所用证件上的信息填写',
        modifySuccess: '修改成功',
        hotelNameCn: '酒店名（中文）',
        hotelNameEn: '酒店名称（英文）',
        isCanBook: '是否可预定',
        hotelFaxPlace: '区号+电话+传真',
        maxLengthTip: '最大输入1333个汉字或4000个英文字母、数字',
        plsTelName: '请输入座机或手机号',
        plsTelNumber: '请输入6-8位的座机号',
        plsPhoneNo: '请输入11位的手机号',
        timeFormat: '时间格式为02:00-14:00',
        timeFormat24: '时间为24小时制',
        plsRightTel: '请输入正确的电话',
        plsHotelCn: '请输入酒店名称（中文）',
        plsHotelEn: '请输入酒店名称（英文）',
        plsChoseBisness: '请选择业务类型',
        plsChoseBrand: '请选择酒店品牌',
        plsChoseStars: '请选择酒店星级',
        plsChoseLevel: '请选择客户级别',
        plsChoseBooking: '请选择是否可预定',
        plsChoseRecom: '请选择是否推荐',
        plsHotelIntroductionCn: '请输入酒店简介（中文）',
        plsHotelIntroductionEn: '请输入酒店简介（英文）',
        plshotelResponsible: '请输入酒店责任人',
        maxFivePerson: '最多添加5个责任人',
        rspHotel: '资源库酒店',
        travelHotel: '差旅酒店',
        hotHotelMax: '热门酒店已经超过配置数量',
        travelHotelRepeat: '差旅库酒店重复映射',
        hotelRepeatTip: '酒店已存在，请重新选择！',
        addPlus: '添加',
        onlyNumbers: '只能输入数字',
        plsHotelAdressCn: '请输入酒店地址(中文)',
        plsHotelAdressEn: '请输入酒店地址(英文)',
        enableTime: 'NOSHOW启用时间点',
        arrivalDateOfBusinessTripCustomers: '商旅客户抵达日期',
        businessTripCustomerDepartureDate: '商旅客户离开日期',
        pleaseSelectTheArrivalDate: '请选择抵达日期',
        pleaseSelectTheDepartureDate: '请选择离开日期',
        plsSelectDate: '请选择启动日期',
        queueDeadline: '排队截止时间',
        selectDeadline: '请选择排队截止日期',
        selectStartDate: '请选择NOSHOW启用日期',
        selectStartTime: '请选择NOSHOW启用时间',
        editHotelRules: '请填写酒店规则',
        editHotelRulesaaa: '请填写导入名单规则',
        exhi: '展会',
        deptSelect: '部门选择',
        auxQueries: '辅助查询',
        company: '公司',
        dept1: '一级部门',
        dept2: '二级部门',
        dept3: '三级部门',
        dept4: '四级部门',
        dept5: '五级部门',
        dept6: '六级部门',
        dept7: '七级部门',
        dept8: '八级部门',
        selected: '已选',
        loading: '加载中…',
        enterDept: '可输入部门编码或名称',
        noDataInquire: '未查询到任何数据',
        link: '链接',
        pic: '图片',
        clickUpDate: '点击上传',
        textUpdateTips: '只能上传jpg/png/gif文件，且不超过500kb',
        bold: '加粗',
        italic: '斜体',
        makeUnorderedList: '无序',
        makeOrderedList: '有序',
        Bookings: '预订量',
        contactName: '姓名',
        contactInfo: '预订人信息',
        plsEntCompany: '请填写公司名称',
        cancelConfirm: '确定',
        bookTime: '预订时间',
        plsDetailAddress: '请填写详细地址,不要重复省市区',
        openingAccount: '账户',
        inveiceType: '增值税专用发票(业务)',
        vehicleTip1: '请选择团组编号',
        vehicleTip2: '请输入航班',
        vehicleTip3: '请选择日期',
        vehicleTip4: '请选择地点',
        vehicleTip5: '请选择/输入地点',
        vehicleTip6: '请输入人数',
        vehicleTip7: '请输入工号',
        vehicleTip8: '请输入备注内容',
        vehicleTip9: '请选择车型',
        vehicleTip10: '请输入账号或邮箱',
        actualEntry: '实际入住录入',
        totalQuantity: '高峰期预定总量',
        stayQuantity: '高峰期入住总量',
        totalOccupancy: '高峰期入住率',
        totalStay: '实际入住',
        totalStayPercentage: '实际入住率',
        dateEntryScope: '日期录入范围',
        recordingSucceeded: '录入成功',
        bytesCannotExceed: '字节数不得超过50个',
        modificationTime: '修改时间',
        numberChange: '变更次数',
        versionRecord: '版本记录',
        groupNum: '团组号',
        orderNum: '订单号',
        directedDate: '预定日期',
        totalChanges: '总变更次数',
        totalChangeRate: '总变更率',
        selectModificationTime: '请选择修改时间',
        beforeTheModification: '修改前',
        checkOutDate: '退房日期',
        changeType: '修改类型',
        afterModification: '修改后',
        edit: '编辑',
        enterMandatoryItems: '请输入必填项',
        preStep: '上一步',
        enterCorrectAmount: '请输入正确的金额',
        theListChanged: '名单已发生变化，是否保存修改内容？',
        editedByAnother: '该名单正在被其他用户编辑，请稍后处理！',
        loadingFlightInformation: '加载航班信息',
        enterUserValid: '请输入有效的工号，w3账号或姓名全拼', // Enter a valid employee ID, W3 account, or full name
        remarks: '备注'
    },
    // common国际化
    common: {
        yes: '是',
        no: '否',
        close: '关闭',
        others: '其他',
        Downtown: '商业区',
        price: '价格',
        nodata: '暂无数据',
        save: '保存', // 1
        submit: '提交',
        continueToAdd: '继续添加',
        back: '返回',
        search: '搜索', // 1
        reset: '重置',
        add: '新增', // 1
        del: '删除', // 1
        import: '导入',
        export: '导出',
        view: '查看',
        tips: '提示',
        edit: '编辑',
        privacyStatement: '隐私声明',
        privacyText: '为了帮助您和您的客户参加华为组织的展会、峰会、会议及访问中国，慧通需要为帮您或您的客户申请签证、安排住宿及车辆、购买机票等目的收集并处理您提交的个人数据（例如您提供的您个人和客户的护照扫描件，电话号码等），请您确认在提交个人数据前，了解并知悉我们的隐私声明，如果您代表您的客户提交个人数据，请您确保已经向您的客户尽到相应的告知义务，并且获得必要的授权。如您需要了解更多信息，可参阅隐私声明。',
        privacyText2: 'In order to help you and your clients participate in the exhibitions, summits, conferences that Huawei organizes and to arrange your visit in China, Smartcom will collect and process the Personal Data you provide (such as copies of passport, phone number of you and your clients etc.) for the purpose of arranging visa, accommodation, vehicular ,plane tickets, etc. Please understand and acknowledge our policies and get the authorization from the data subject for the above purpose before you submit any Personal Data. For more information, please refer to the privacy policy.',
        privacyRead: '已阅读并同意',
        sure: '确定', // 1
        ok: '确认',
        cancel: '取消', // 1
        agree: '同意',
        reject: '驳回',
        approved: '已审批',
        disapproving: '不同意',
        revoked: '撤销',
        go: 'GO', // 1
        upload: '上传',
        operation: '操作', // 1
        coverImg: '主图',
        setCoverImg: '设为主图',
        uploadTip: '仅支持jpg，png；每张照片最大3M；至少1张，最多{0}张，推荐上传图片尺寸长高比9:6（如：1500*1000 | 900*600 | 240*160）',
        inputPlaceholder: '请输入',
        selectPlaceholder: '请选择',
        downloadTemp: '下载模板',
        imgPlaceholder: '请上传图片',
        orderDetail: '订单详情', // 1
        checkMyWallet: '查看我的钱包', // 2
        address: '地址', // 1
        amount: '总金额', // 1
        name: '姓名', // 1
        phone: '手机', // 1
        email: '邮箱', // 1
        distance: '距离', // 1
        directDistance: '直线距离约',
        someQueued: '部分房型需排队',
        allLined: '房型均需排队',
        noneReserved: '房型均不可预定',
        someReserved: '部分房型不可预定',
        startUp: '起', // 1
        advSearch: '高级搜索',
        bookingNow: '立即预订', // 1
        contact: '联系人',
        seeMore: '查看更多', // 1
        more: '更多',
        shutUp: '收起',
        bookInst: '预订须知', // 1
        LocationOf: '所处位置', // 1
        TraffCond: '交通情况', // 1
        surrCond: '周边情况', // 1
        travelRoute: '出行路线', // 1
        collection: '收藏', // 1
        cancelFavorite: '取消收藏', // 1
        share: '分享', // 1
        gender: '性别', // 1
        isEmp: '是否员工', // 1: '性别', // 1
        position: '职位', // 1
        requiredField: '必填',
        selectRequired: '必选',
        leave: '离开', // 1
        payWay: '付费方式', // 1
        days: '天',
        vehicular: '辆',
        note: '备注', // 1
        vehicleRemark: '请在此备注详细用车信息，如：用车路线、接送机航班号、接送站列车号、其他车辆相关信息等。',
        switchGroup: '切换团组', // 1
        guestBing: '主宾',
        man: '男',
        women: '女',
        createApplication: '创建申请',
        cancelAttendance: '取消参会',
        placeholder: {
            pleaseSelectCity: '请选择城市',
            pleaseSelectCountry: '请先选择国家',
            pleaseSelectProvince: '请先选择省份'
        },
        log: {
            title: '日志',
            operationUser: '操作人',
            operationDate: '操作时间'
        },
        tip: {
            confirmOperation: '确认执行当前操作吗？',
            selectData: '请至少选中一条数据',
            delConfirm: '确认删除当前数据吗？',
            delSuccess: '删除成功',
            delFailed: '删除失败',
            abolitionSuccess: '废除成功',
            abolitionFailed: '废除失败',
            saveSuccess: '保存成功',
            sveFailed: '保存失败',
            exportSuccess: '导出成功',
            exportFailed: '导出失败，请稍后再试',
            importSuccess: '导入成功',
            importFailed: '导入失败，请稍后尝试',
            imgUploadFailed: '图片上传失败',
            imgUploadLimit: '图片数量超出限制！',
            startTimeRequire: '请选择开始时间',
            endTimeRequire: '请选择结束时间',
            timeOutRange: '您选择的时间不在可用时间范围，请重新选择',
            dataChange: '日期不能选当天!',
            allocation: '分配成功',
            delChenkInPeople: '该入住人将删除，请确认！',
            isCancelModify: '名单已发生变化，是否取消修改内容？',
            updateSuccess: '更新成功',
            updateFailed: '更新失败'
        },
        valid: {
            enterCorrectIdCardNum: '请输入正确的身份证号码',
            enterCorrectIdPassportNum: '请输入正确的护照号码',
            enterIssuedBy: '请输入正确的护照签发地',
            enterPhoneNum: '请输入正确的手机号码'
        },
        importing: '导入中',
        outsideLinkTips: '您即将打开外部链接，是否继续？',
        privacyTips: '导出的页面数据包含敏感信息，请谨慎处理并确保在安全的环境下使用或存储!'
    },
    // 菜单
    menu: {
        personalCenter: '个人中心', // 1
        exhiConfig: '展会配置',
        resourcesConfig: '资源配置',
        hotelConfig: '酒店资源配置',
        planeTickets: '机票资源配置',
        trainTickets: '火车票资源配置',
        leisureRes: '休闲资源配置',
        userPerm: '用户权限配置',
        systemManage: '系统管理',
        roleManage: '角色管理',
        permManage: '权限管理'
    },
    leftMenu: {
        recentOrders: '近期订单', // 1
        hotelOrders: '酒店订单', // 1
        vehicleOrders: '用车订单',
        applicationManagement: '我的待办',
        switchConfig: '开关配置',
        airTicketOrders: '机票订单',
        leisureResourceOrders: '休闲资源订单',
        personalInfo: '个人信息', // 1
        commonContacts: '常用联系人', // 1
        commonAddress: '常用地址', // 1
        commonInvoice: '常用发票', // 1
        myImportExport: '我的导入导出',
        commonInformation: '常用信息',
        myFavorites: '我的收藏', // 1
        myMessage: '我的消息',
        help: '帮助', // 1
        orderManagement: '订单管理',
        businessQueueOrders: '商旅酒店排队订单',
        privacyPolicy: '隐私声明',
        personManage: '人员管理',
        BusinessStatistics: '商旅预订统计'
    },
    // element组件
    el: {
        colorpicker: {
            confirm: '确定', // 1
            clear: '清空'
        },
        datepicker: {
            date: '日期',
            now: '此刻',
            today: '今天',
            cancel: '取消', // 1
            clear: '清空',
            confirm: '确定', // 1
            selectDate: '选择日期',
            selectDateTime: '选择日期时间',
            selectTime: '选择时间',
            startDate: '开始日期',
            startTime: '开始时间',
            endDate: '结束日期',
            endTime: '结束时间',
            prevYear: '前一年',
            nextYear: '后一年',
            prevMonth: '上个月',
            nextMonth: '下个月',
            year: '年',
            month: '月',
            month1: '1 月',
            month2: '2 月',
            month3: '3 月',
            month4: '4 月',
            month5: '5 月',
            month6: '6 月',
            month7: '7 月',
            month8: '8 月',
            month9: '9 月',
            month10: '10 月',
            month11: '11 月',
            month12: '12 月',
            // week: '周次',
            weeks: {
                sun: '日',
                mon: '一',
                tue: '二',
                wed: '三',
                thu: '四',
                fri: '五',
                sat: '六'
            },
            months: {
                jan: '一月',
                feb: '二月',
                mar: '三月',
                apr: '四月',
                may: '五月',
                jun: '六月',
                jul: '七月',
                aug: '八月',
                sep: '九月',
                oct: '十月',
                nov: '十一月',
                dec: '十二月'
            }
        },
        select: {
            loading: '加载中',
            noMatch: '无匹配数据',
            noData: '无数据',
            placeholder: '请选择'
        },
        cascader: {
            noMatch: '无匹配数据',
            loading: '加载中',
            placeholder: '请选择'
        },
        pagination: {
            goto: '前往', // 1
            pagesize: '条/页', // 1
            total: '共 {total} 条',
            pageClassifier: '页' // 1
        },
        messagebox: {
            title: '提示',
            confirm: '确定', // 1
            cancel: '取消', // 1
            error: '输入的数据不合法!'
        },
        upload: {
            deleteTip: '按 delete 键可删除',
            delete: '删除', // 1
            preview: '查看图片',
            continue: '继续上传'
        },
        table: {
            emptyText: '暂无数据',
            confirmFilter: '筛选',
            resetFilter: '重置',
            clearFilter: '全部',
            sumText: '合计'
        },
        tree: {
            emptyText: '暂无数据'
        },
        transfer: {
            noMatch: '无匹配数据',
            noData: '无数据',
            titles: ['列表 1', '列表 2'],
            filterPlaceholder: '请输入搜索内容',
            noCheckedFormat: '共 {total} 项',
            hasCheckedFormat: '已选 {checked}/{total} 项'
        },
        image: {
            error: '加载失败'
        }
    },
    // 头部 Header.vue国际化
    header: {
        exhiHome: '展会首页', // 1
        home: '首页', // 1
        hotel: '酒店', // 1
        vehicle: '用车', // 1
        airTicket: '机票', // 1
        trainTicket: '火车票', // 1
        leisureResources: '休闲资源', // 1
        login: '登录',
        logout: '注销',
        dearUser: '尊敬的用户：',
        tips1: '为了您更好的使用体验，建议您优先选用注册华为账号形式登录爱上会平台进行资源预定；',
        tips2: '如需使用QQ、WeChat、Linkedin等第三方账号登录操作，请选择在移动端登录爱上会；',
        qrcode: '使用手机扫码进入',
        close: '{0}S后关闭',
        lang: 'EN', // 中文模式下这里显示EN
        myOrder: '我的订单', // 1
        hotelOrders: '酒店订单', // 1
        vehicleOrders: '用车订单',
        applicationManagement: '我的待办',
        personalCenter: '个人中心', // 1
        exhiConfig: '展会配置',
        switchConfig: '开关配置',
        mediaPersonnel: '人员',
        resourcesConfig: '资源配置'
    },
    // 底部 Footer.vue国际化
    footer: {
        copyRight: 'Copyright © 2019 Smartcom. All rights reserved', // 1
        contactUs: '联系我们',
        confirmRevoked: '您确定要撤销吗？',
        statement: '隐私声明',
        complaint: '违法和不良信息举报'
    },
    // 资源首页 Exhi.vue国际化
    exhi: {
        hotHotel: '热门酒店',
        vehicleService: '用车服务', // 1
        ticketService: '机票服务', // 1
        trainService: '火车票服务', // 1
        leisureResources: '休闲资源', // 1
        timeTip: '您选择的时间不在可用范围内，请重新选择',
        lockTip: '您选择的入住日期在锁定范围内，不可预订，请重新选择。'
    },
    // 资源首页_Banner组件 Banner.vue国际化
    banner: {
        hotel: '酒店', // 1
        vehicle: '用车', // 1
        ticket: '机票', // 1
        trainTickets: '火车票', // 1
        leisureResources: '休闲资源' // 1
    },
    // 资源首页_用车服务组件 VehicleBlock.vue国际化
    vehicleService: {
        meetCar: '迎接用车', // 1
        offCar: '送行用车', // 1
        theTrip: '趟',
        noGroupTips: '您当前没有已审批通过的团组，可在icims系统完成',
        groupApp: '团组申请',
        postCarApp: '后再次申请用车，谢谢',
        gotIt: '知道了'
    },
    // 资源首页_Banner搜索组件 Search.vue国际化
    search: {
        personal: '个人预订', // 1
        hotelName: '酒店名',
        address: '地址', // 1
        reSearch: '重新搜索', // 1
        endTime: '结束时间',
        startTime: '开始时间',
        changeTip: '您修改了查询条件，即将为您重新获取酒店资源，确定开始吗？',
        noMoreRemind: '确定，以后不用再提醒',
        moreRemind: '确定，每次提醒我'
    },
    // 酒店列表 HotelList.vue,PersonalList.vue,BusinessList.vue国际化
    // 酒店列表 HotelListInfo.vue,PersonalHotelListInfo.vue,BusinessHotelListInfo.vue国际化
    // 酒店列表 - 浏览历史 HotelItem.vue国际化
    hotelListC: {
        searchFor: '为您搜索到{0}家酒店',
        searchFor2: '为您搜索到{0}家酒店',
        home: '家',
        hotel: '酒店', // 1
        stars: '酒店星级', // 1
        noSearchData: '无符合查询条件的记录',
        hotelProfile: '酒店简介', // 1
        checkRoomType: '查看房型', // 1
        browseHistory: '浏览记录', // 1
        returnList: '返回列表',
        centerDistance: '距离会展中心',
        venueDistance: '会场距离' // 1
    },
    // 酒店列表-酒店搜索筛选组件 AdvancedFilter.vue,PersonalAdvancedFilter.vue,BusinessAdvancedFilter.vue国际化
    advancedFilter: {
        priceRange: '价格区间', // 1
        hotelStars: '酒店星级', // 1
        locationArea: '位置区域', // 1
        advancedSearch: '高级筛选', // 1
        emptyFilter: '清空筛选', // 1
        priceRangeInt: '请输入0-999999999的数字',
        priceRangeTip: '价格区间 起始价格不能大于结束价格',
        notLimited: '不限', // 1
        pavilion: '展馆', // 1
        hotSort: '推荐排序' // 1
    },
    // 酒店列表 - 查看房型组件 BookRoomType.vue,BusinessBookRoomType.vue,PersonalBookRoomType.vue国际化
    checkRoomType: {
        newAllowance: '未使用间数',
        hasSelected: '已选择',
        room: '房间', // 1
        priceAll: '总价',
        roomType: '房型',
        allowance: '余量', // 1
        maximunAllowancePerDay: '单日最大余量',
        allowanceDetail: '余量详情', // 1
        queuDetail: '排队详情', // 1
        personNum: '入住人数', // 1
        roomTypeState: '房型状态',
        selQuantity: '选择数量',
        houseType: '选择房型',
        addReservation: '添加预订',
        addReservationPd: '添加排队',
        added: '已添加',
        dateNotEmpty: '日期不能为空',
        selectRoomNum: '请选择房型',
        groupRange: '你暂无可预订该酒店的团组，该酒店仅有VIP+级别的团组可预订，如需预订请先在icims中申请该级别的团组',
        noRoom: '全部缺房',
        queue: '已有{0}人排队',
        queueing: '现在{0}人排队',
        choiceOtherRoom: '建议您选择其他房型或房量充足的酒店',
        notEnoughRoom: '余量不足',
        waitingDate: '{0}号缺房排队等待，修改日期可以提前预订成功',
        buildingArea: '建筑面积',
        roomTypeDetail: '房型详情',
        seeMore: '查看详情',
        bedType: '床型', // 1
        breakfast: '早餐',
        noBreakfast: '无早',
        singleMorning: '单早',
        doubleMorning: '双早',
        containsEarly: '含早',
        plicy: '政策',
        timeLimitedCancel: '限时取消',
        freeOfCancel: '免费取消',
        Uncancelable: '不可取消',
        partfull: '部分满房',
        fullRoom: '满房',
        singleBed: '单床',
        twinBeds: '双床',
        queenBed: '大床',
        roundBed: '圆床',
        reserAvail: '可预订', // 1
        queuRequired: '需排队' // 1
    },
    // 预订流程-Reservation.vue及其子组件国际化
    reservation: {
        roomTypeNull: '房量不能为空!',
        completeApplication: '已完成酒店预订申请', // 1
        harfCountRequire: '请输入正确的半自费金额',
        requestfailed: '订单详情请求失败',
        confirm: '预订成功', // 1
        submittedSuccessfully: '提交成功，待车辆管理员安排',
        waiting: '排队等待', // 1
        rowStatu: '排房状态', // 1
        addPerson2: '添加合住人', // 1
        stay: '入住', // 1
        addUstomer: '添加入住客户', // 1
        bookRoomType: '预订房型', // 1
        bookHotel: '预订酒店', // 1
        HotelDetailshotelPolicycontent: '以预订酒店设定的规则为准。',
        hotelPolicypersonal: '酒店政策：',
        hotelPolicy: '酒店政策：月结才能享受协议价，现付按前台价！',
        businessTip: '入住时间不能早于当前时间且不能大于退房时间',
        inOutTime: '入住/离开时间', // 1
        household: '入住人', // 1
        state: '状态',
        stayInfo: '入住信息', // 1
        night: '晚',
        deleteRoomType: '删除房型',
        inOutDate: '入离日期', // 1
        roomNum: '房间数量', // 1
        tipsDefaultTime: '请填写客户抵达时间，默认酒店入住时间为15:00，退房时间为12:00',
        must1day: '选择的时间跨度必需大于1天',
        must1cust: '至少添加一个客户',
        confirmCancel: '确认删除该房间的申请吗?',
        groupChange: '当前预订申请只能选择同一个团组的客户，目前已经添加了{0}团组的客户，是否要清空已添加的客户信息？',
        selectCust: '请选择入住客户',
        roomMaxCust: '每个房间最多住{0}人',
        oppositeSex: '您确定安排男女合住吗?',
        rebook: '选择中存在预定成功状态的客户{0}，请确认是否重新预订？',
        cancelRoomType: '确定取消该房型申请？',
        selectGroup: '选择团组', // 1
        selectGroupPls: '请选择团组', // 1
        groupplaceHolder: '可输入团组编号或者来客单位进行搜索',
        visiUnit: '来客单位', // 1
        groupNo: '团组编号', // 1
        changeRoomType: '更改房型',
        changeRoomTypeTj: '添加房型',
        oneRoom: '间',
        oneRoomY: '间夜',
        confirmOrderInfo: '确认订单信息',
        orderFailed: '订单提交失败',
        bookPersonInfo: '预订人信息', // 1
        contactInformation: '联系人信息',
        areaName: '地区部',
        areaNameEmptyTip: '地区部不能为空',
        AmountPay: '应付金额', // 1
        submitOrder: '提交订单',
        exceedBudget: '团组已超过预算，需要进行预算追加或者释放资源',
        plusbudget: '追加预算',
        emailMsgTwo: '邮箱不能为空',
        emailMsgOne: '请输入正确的邮箱格式',
        phoneMsgOne: '手机号不能为空',
        nameMsgOne: '姓名不能为空',
        accommInfoComf: '您有住宿信息未填写或填写的信息未确认，请先进行信息核对',
        ordersubmitsuccess: '您的订单已提交，请及时导入名单！',
        confirmText: '预订成功状态的房间已安排;',
        waitingText: '排队等待状态的房间将视情况进行安排，请持续关注！',
        carService: '用车服务', // 1
        occupancyInfo: '入住人信息',
        addHotel: '添加酒店',
        fromEMS: '团组信息来自EMS系统',
        departName: '需求部门名称',
        belongsBG: '所属BG',
        customerCategory: '客户类别',
        applicant: '申请人',
        contact: '联系方式',
        totalBudget: '总预算',
        qroupQueueTip: '该团组已经在排队中，请重新选择其他团组',
        plsEnterInteger: '请输入正整数',
        roomTypeNoEmpty: '房量不能为空',
        currHotelTip: '当前酒店至少保留一个房型',
        plsPerfectInfo: '请完善必填信息',
        price: '单价',
        num: '数量',
        cost: '金额', // 1
        totalCost: '金额', // 2
        subtotalCost: '小计金额', // 2
        submitSuccess: '提交成功',
        choiceHotel: '选择酒店',
        searchPlaceholder: '请输入酒店名/地址进行搜索',
        hotelPic: '酒店图片',
        hotelName: '酒店名称',
        stars: '星级',
        addRoomType: '添加房型',
        changeHotel: '切换酒店',
        isConfirm: '是否确认预订',
        enterGroupNo: '输入团组编号',
        updateSuccess: '更新成功',
        atLeastOneHotel: '当前订单至少保留一个酒店',
        tipMsg: '每间最多住2人',
        addPerson: '添加入住人',
        saveContact: '保存为常用联系人',
        plsEnterName: '请输入姓名',
        plsEnterEmail: '请输入邮箱',
        invoice: '发票',
        noNeed: '不需要',
        need: '需要',
        invoiceTip1: '国家总局公告：自2017年7月1日起，企业索取的普通发票需填写纳税人识别号，不符合规定的发票，不得作为合法税收凭证。',
        invoiceTip2: '温馨提示：请按照公司真实注册信息填写，如填写内容有误，平台有权利不提供专用发票开具寄送服务，谢谢配合！',
        invoiced: '开具发票',
        canBeIssued: '可开具5张不同/相同金额的发票',
        invoiceCost: '发票{0}金额',
        plsInvoiceHeadUp: '请输入发票抬头',
        plsCompanyAddress: '请输入公司地址',
        plsCompanyTel: '请输入公司电话',
        plsBankName: '请输入开户银行名称',
        plsBankAccount: '请输入开户银行账号',
        plsCountry: '请选择国籍',
        plsTaxpayerIdentificationNum: '请输入纳税人识别号',
        identificationTips: '税务登记证上唯一识别企业的税号，通常由15位，18位或20位码组成。',
        invoiceIndicate: '发票注明酒店名和入离时间',
        selfCosts: '自行承担快递费用',
        mailAddress: '邮件地址',
        addAddress: '新增地址',
        plsRecipient: '请输入收件人姓名',
        recipientName: '收件人姓名',
        recipient: '收件人',
        ChoiceArea: '请选择省市区',
        location: '所在地',
        plsDetailedAddress: '请填写详细地址',
        streetInfo: '街道信息',
        detailedAdderssTip: '请填写详细地址，不需要重复填写省市区',
        zipCode: '邮政编码',
        plsZipCode: '请填写邮政编码',
        addressTip: '确认后将保存为常用配送地址',
        completeRead: '我已阅读并接受《取消规则》',
        plsPhoneMsg: '请输入正确的手机号',
        plsEmailMsg: '请输入正确的邮箱地址',
        plsCountryMsg: '请选择国家号',
        plsInteger: '填写发票金额必须为正整数',
        plsInvoiceCost: '多张发票累计必须等于发票金额',
        plsRightTel: '请输入正确的电话,如：{0}',
        bankLength: '银行账号为9-50位字符',
        taxNoLength: '税号长度为15位、18位、20位',
        addressLength: '单位地址仅支持5-85个字符,一个汉字算3个字符',
        plsRoomStay: '请填写房间入住人',
        plsBookName: '请填写预订人姓名',
        plsBookPhone: '请填写预订人手机',
        plsBookEmail: '请填写预订人邮箱',
        guaranteeNote: '需要担保默认备注',
        noCompany: '暂无常用公司抬头',
        Sunday: '周日',
        Monday: '周一',
        Tuesday: '周二',
        Wednesday: '周三',
        Thursday: '周四',
        Friday: '周五',
        Saturday: '周六',
        countInvoice: '{0}张',
        nextDay: '00:00(次日)',
        floor: '楼层', // 1
        roomCost: '房费', // 1
        payOnline: '在线支付',
        youSelected: '您已经选择',
        to: '至',
        total: '共',
        aRoom: '间房',
        custplaceHolder: '可输入客户姓名进行搜索', // 1
        person: '人',
        addcust: '添加住客'
    },
    // 酒店资源配置详情国际化
    hotelResDetail: {
        roomTypeName: '房型名称',
        hotelBasicInfo: '酒店基本信息',
        roomTypeInfo: '房型信息', // 1
        roomNumInfo: '房量信息',
        hotelOverview: '酒店概况',
        plsEnterType: '请输入房型',
        plsSelectType: '请选择房型',
        company: '公司',
        personal: '个人',
        business: '商旅',
        empty: '置空',
        referencePrice: '参考价',
        companyRoomNum: '公司房量',
        businessRoomNum: '商旅房量',
        personalRoomNum: '个人房量',
        hotelNameCn: '酒店名称（中文）',
        hotelNameEn: '酒店名称（英文）',
        hotelBrand: '酒店品牌',
        customerLevel: '客户级别',
        whetherToBook: '是否可预订',
        bookingMail: '预订邮箱',
        openDate: '开业时间',
        renovationYears: '装修年限',
        openingHours: '营业时间',
        roomCount: '客房间数',
        checkInTime: '最早入住时间',
        checkOutTime: '最晚离店时间',
        isHot: '是否推荐',
        hotSort: '推荐排序', // 1
        hotelTel: '酒店客服电话',
        hotelFax: '酒店传真',
        contactName: '酒店责任人',
        tel: '电话', // 1
        feature: '酒店特点',
        introductionCn: '酒店简介（中文）',
        introductionEn: '酒店简介（英文）',
        location: '位置信息',
        domesticInternational: '国内／国际',
        domestic: '国内',
        international: '国际',
        country: '国家',
        city: '城市',
        districtCode: '行政区',
        baiduCoordinate: '百度地图坐标',
        googleCoordinate: '谷歌地图坐标',
        hotelAddressCn: '酒店地址（中文）',
        hotelAddressEn: '酒店地址（英文）',
        locationArea: '位置区域',
        hotelPic: '酒店图片',
        hotelFacilities: '酒店设施', // 1
        publicFacilities: '公共设施',
        meetingFacilities: '会议服务设施',
        diningFacilities: '酒店餐饮设施',
        freeFacilities: '酒店免费设施',
        guestRoomFacilities: '酒店客房设施',
        otherFacilities: '其他设施'
    },
    // 个人酒店订单列表 & 详情
    personalOrder: {
        bookingDate: '预订日期', // 1
        plsChoiceDate: '请选择预订日期',
        toPay: '去支付', // 1
        payMethod: '支付方式', // 1
        actualAmount: '实付金额', // 1
        serviceAmount: '含税服务费',
        reachTime: '到店时间', // 1
        basedOnLocalTime: '以当地时间为准', // 1
        occupancyInfo: '入住人信息',
        invoiceInfo: '发票信息', // 1
        invoiceType: '发票类型',
        specificInvoice: '增值税专用发票', // 1
        invoiceDetails: '发票明细', // 1
        bookingAccommodation: '代订住宿费', // 1
        companyFullName: '公司全称', // 1
        companyAddress: '公司地址', // 1
        companyTel: '公司电话', // 1
        invoiceAmount: '发票金额', // 1
        bankName: '开户银行名称', // 1
        bankAccount: '开户银行账号', // 1
        taxpayerIdentificationNum: '纳税人识别号', // 1
        whetherToIndicate: '是否注明酒店名称和入离日期',
        invoicesDeliver: '发票递送方式',
        express: '快递',
        himself: '自取', // 1
        invoicesExpressInfo: '发票快递信息',
        invoicesHimselfAddress: '发票自取地址',
        noInvoices: '不需要发票',
        ifNeedInvoices: '如需发票，请联系', // 1
        cancelRule: '取消规则', // 1
        cancelRuleTextTip: '请仔细阅读取消规则，规则时间内取消请联系客服(0755-28566666)',
        Individualbookinghotelcancellationrulecontent: '由于展会期间房源紧张，订单需预付，确认后不可取消变更，如未入住全额房费与全额服务费将不予退还，共计{CurrencyUnit}{Amount}。',
        noInvoicescontent: '此发票由慧通差旅开具，将在您离店后的7-15个工作日开具发票，并通知您领取。发票将在您退房后按照预订时订单总金额开具，为避免信息有误,若您订单行程有变，务必第一时间联系差旅客服修改；以下信息填写后请认真核对，若因信息有误引起的相关损失，需您自付，谢谢配合！',
        orderTipStart: '订单需预付，支付成功后如需修改请在', // 1
        stayDate: '入住日期',
        orderTipEnd: '前通知我们，过时订单不可取消变更，如未入住首日房费将不予退还。' // 1
    },
    // 车辆相关
    vehicleInfo: {
        receiveSignTip: '内容不宜过长,建议填写客户公司名称',
        minprice: '起', // 1
        requireTip: '请填写用车时间',
        vehicheInfo: '用车信息',
        howArive: '抵达方式',
        howLeave: '离开方式',
        flight: '航班',
        leaveTime: '出发时间',
        departureTips: '建议提前于起飞时间3小时出发',
        meetPlace: '迎接地点',
        departure: '出发地点',
        placeDelivery: '送达地点',
        pickCard: '接机牌',
        userInfo: '用户信息',
        custNumber: '客户人数',
        escortNumber: '陪同人数',
        callNumber: '联系电话',
        meetCar: '迎接用车', // 1
        offCar: '送行用车', // 1
        meetCarApp: '迎接用车申请',
        offCarApp: '送行用车申请',
        ridersNumber: '乘车人数',
        theTrip: '趟',
        intLength1: '请输入1-999999正整数',
        intLength0: '请输入0-999999正整数',
        charLength: '输入的字符长度超出限制',
        vehConfigTips: '没有查询到车辆相关配置信息',
        groupDudgetTips: '团组超预算,是否追加预算，点击确定跳转到追加预算页面',
        orderProces: '订单流程指引图',
        selectVehTime: '选择用车时间',
        selectVehType: '选择用车类型',
        vehType: '用车类型',
        selectNeedVehTyp: '选择所需类型的用车',
        fillOrder: '填写订单',
        fillVehInfo: '填写用车信息及用户信息',
        successSubOrder: '成功提交订单',
        confirmCarInfo: '确认用车信息提交成功',
        waitDelivery: '等待派车',
        waitAcceptDeli: '等待受理派车开启行程',
        reSearch: '重新搜索', // 1
        noGroupTips: '您当前没有已审批通过的团组，可在icims系统完成',
        groupApp: '团组申请',
        postCarApp: '后再次申请用车，谢谢',
        gotIt: '知道了',
        viewUpOffIssues: '查看接送机相关问题',
        stayTuned: '此功能正在建设中，敬请期待!',
        orderNo: '订单编号', // 1
        meet: '迎接',
        meetMeta: '迎接',
        off: '送行',
        letGo: '出发',
        arrived: '抵达',
        served: '送达',
        time: '时间',
        schedDate: '预订日期', // 1
        flightNo: '航班号',
        carOrder: '用车订单',
        queryConditionTit: '订单编号/团组编号/出发地/目的地',
        orderState: '订单状态',
        byCarDate: '用车日期',
        inputByCarDate: '请输入用车日期',
        inputSchedDate: '请输入预订日期',
        arrivalTime: '抵达时间',
        departureTime: '出发时间',
        modifOrder: '修改订单', // 1
        bookAgain: '再次预订', // 1
        driverInfo: '司机信息',
        carType: '车型',
        carCard: '车牌',
        driverName: '司机姓名',
        cancelOrder: '取消订单', // 1
        cancelTips: '您确定取消该订单吗？',
        submitted: '已提交', // 1
        accepted: '已受理',
        carDispatched: '已派车',
        inPlace: '已到位',
        onBoard: '已上车',
        evaluated: '待评价',
        completed: '已完成',
        cancelled: '已取消',
        orderCancelSucc: '订单取消成功',
        needNoshowFee: '按照取消规则规定，本次操作将扣除Noshow费{0}，请确认是否继续执行？',
        orderCancelfailed: '订单取消失败',
        contact1: '联系人1',
        contact2: '联系人2',
        contactPhone1: '联系人手机1',
        contactPhone2: '联系人手机2',
        evaluation: '评价',
        carService: '用车服务', // 1
        marginPreview: '余量预览',
        enterTheVehicleQuantity: '请输入用车数量',
        usage: '用途',
        selectaDuration: '请选择时长',
        enterTheNumber: '请输入每日用车数量',
        insufficientNumber: '[{0}] 数量不足，请重选或提交排队!',
        maximumTip: '最大输入165个汉字或500个英文字母、数字',
        selectaUsage: '请选择用途',
        selectaVehicle: '请选择车型',
        selectTheVehicle: '请选择用车开始时间',
        selectTheVehicleTime: '请选择用车结束时间',
        customerReception: '客户接待',
        pleaseReserve: '请至少保留一条',
        numberOf: '乘客人数',
        enterTheChinese: '请输入车型名称',
        prearranged: '预定过的',
        car: '辆',
        estimatedPayment: '预计支付',
        draft: '草稿',
        waitingForVehicle: '待车辆组受理',
        closed: '已关闭',
        selectDate: '使用日期选择',
        numberOfPersonnel: '核载人数',
        dailyUsage: '每日用量',
        dailyTime: '每日用时',
        addReservation: '添加预订',
        addingaqueue: '添加排队',
        reservationExpired: '已过开放预订时间',
        amaximum: '最多添加5个押车订单',
        batchBooking: '批量预订',
        contentChanged: '内容发生变化，是否确认退出?',
        theBackgroundDoes: '后台未返回订单ID',
        failedToSubmitTheOrder: '提交订单出错',
        pleaseSetMandatoryParameters: '请填写必填项',
        businessTravel: '商旅接车',
        theApplication: '申请已提交成功，请继续关注派车!',
        helloYour: '您好，您的',
        orderListQuery: '订单列表查询',
        queryError: '查询出错',
        businessTravelVehicle: '商旅用车',
        requestingDepartment: '需求部门',
        addVehicle: '添加车辆',
        editBusiness: '商旅用车编辑',
        addBusiness: '商旅用车申请',
        juncture: '接',
        staked: '押',
        pickup: '接车',
        endTimeTip: '结束时间不能小于开始时间',
        hour: '小时',
        noIntroduction: '暂无车辆简介',
        noDate: '暂无可预订日期',
        hou: '时',
        day: '天'
    },
    // 机票、火车票、休闲资源推荐
    otherResources: {
        ticket: '机票服务', // 1
        trainTickets: '火车票服务', // 1
        leisureResources: '休闲资源', // 1
        starts: '起', // 1
        discount: '折'
    },
    // 资源配置国际化
    resourcesConfig: {
        breadcrumb: {
            hteol: '酒店资源配置',
            rule: '酒店规则',
            res: '资源配置'
        },
        hotelList: {
            tab: {
                hteol: '酒店配置',
                rule: '酒店规则'
            },
            all: '全部',
            hotelName: '酒店名称', // 1
            hotelFrom: '资源来源',
            stars: '酒店星级', // 1
            address: '酒店地址', // 1
            isEnable: '是否可预订',
            isHot: '推荐酒店',
            hotSort: '推荐排序', // 1
            edit: '编辑酒店',
            add: '新增酒店',
            addRoomType: '添加房型',
            exportHotel: '酒店信息导出',
            exportImportRoom: '房型房量导入导出',
            importRoom: '房型房量导入',
            exportRoom: '房型房量导出',
            hotelNamePlaceholder: '请输入酒店名称',
            tip: {
                delConfirm: '请确认是否删除 {0} 酒店及其相关配置房型、房量信息？',
                hotelReference: '{0}酒店已被引用，不允许删除，请先清空该酒店下的配置信息！'
            }
        },
        roomType: {
            name: '房型', // 1
            nameCn: '房型（中文）',
            nameEn: '房型（英文）',
            windowType: '窗型',
            area: '面积（M²）',
            floor: '楼层', // 1
            bedType: '床型', // 1
            bedTypeLength: '床型长度（米）',
            bedTypeWidth: '床型宽度（米）',
            averagePrice: '平均房价',
            serviceFee: '平均服务费',
            businessType: '业务类型',
            businessTypes: {
                company: '公司预订', // 1
                individual: '个人预订', // 1
                business: '商旅预订' // 1
            },
            addRoomQuantity: '添加房量',
            editRoomQuantity: '编辑房量',
            dialog: {
                viewRoomType: '查看房型', // 1
                addTitle: '新增房型',
                editTitle: '编辑房型'
            },
            windowTypes: {
                yes: '有窗',
                no: '无窗'
            },
            roomTotal: '房间总数',
            whetherToBook: '是否可预订',
            whetherToBooks: {
                yes: '可预订', // 1
                no: '不可预订'
            },
            index: '序号',
            internetType: '上网方式', // 1
            internetTypes: {
                wireless: '无线上网',
                wired: '有线上网',
                no: '无网络'
            },
            image: '房型图片',
            valid: {
                nameCnRequired: '请输入房型中文名称',
                nameEnRequired: '请输入房型英文名称',
                nameCnRequiredTravel: '请选择房型',
                priceRequired: '请输入价格',
                averagePriceRequired: '平均房价不能为空',
                roomCountRequired: '请输入房间总数',
                nameValid: '最大输入33个汉字或100个英文字母、数字',
                imgSize: '上传图片大小不能超过 3M!'
            }
        },
        roomQuantity: {
            dateRange: '新增房量日期范围',
            date: '日期',
            quantity: '分配量',
            remaining: '余量',
            status: '房态', // 1
            quote: '报价',
            serviceFee: '服务费',
            noBreakfast: '无早',
            singleMorning: '单早',
            doubleMorning: '双早',
            containsEarly: '含早',
            valid: {
                required: '请输入分配量',
                range: '编辑后的房量不可小于当前房量和余量的差额'
            }
        },
        log: {
            quantityPre: '分配量变更前',
            quantity: '分配量变更后'
        },
        userPermission: {
            userAccount: '用户账号',
            userName1: '用户名',
            userName: '角色名',
            userStatu: '角色状态',
            selUser: '选择角色',
            prompt: '温馨提示：请勿在此添加展会管理员角色，如需添加请在展会信息配置中授予相应权限。',
            addUserPrompt: '温馨提示：如果添加的用户存在相应角色（不管是否过期）都不可对这个用户做任何操作,需要对其延期请返回用户角色管理页面对其操作。',
            delUserPrompt: '您要删除的内容可能您没有权限删除(如:System Admin)或者不能再此处删展会管理员!',
            sureDel: '您确定删除此数据和它的相关数据？',
            inputUser: '请输入角色名',
            inputInstruction: '请输入说明',
            instruction: '说明',
            selOneUser: '请选择至少一个角色',
            privilegeExtension: '权限延期',
            extension: '延期',
            extensionSuccess: '延期成功',
            effectDate: '生效日期',
            overdueDate: '过期日期',
            extensionDate: '延期日期',
            extensionErrTip: '您所设置的延期日期小于生效日期，这部分数据将不予以延期操作',
            sureExtension: '是否确认延期',
            endBigStar: '开始日期不能大于结束日期',
            noEffect: '未生效',
            isOverdue: '已过期',
            isExtension: '已生效',
            soonOverdue: '即将过期',
            arrival: '抵达日期不得大于离开日期'
        }
    },
    // 车辆资源配置国际化
    vehicleConfig: {
        vehicleTypeConfiguration: '车型配置',
        vehicleRule: '车辆规则',
        cancellationRuleDesc: '取消规则说明',
        cancellationRule: {
            title: '取消规则',
            checkInDaysMin: '取消预订离开始时间范围下限',
            checkInDaysMax: '取消预订离开始时间范围上限',
            fee: '手续费扣费比率（%）'
        },
        vehicleLock: {
            title: '用车锁设置',
            lockType: '锁类型',
            lockTime: '锁定时间',
            selectLockTime: '选择锁定时间'
        },
        vehicleTime: {
            title: '用车时间设置',
            useVehStartTime: '用车开始时间',
            selectUseVehStartTime: '选择用车开始时间',
            useVehEndTime: '用车结束时间',
            selectUseVehEndTime: '选择用车结束时间'
        },
        btn: {
            import: '导入',
            importTemplate: '导入模板',
            export: '导出'
        },
        form: {
            title: {
                add: '新增车型',
                edit: '编辑车型',
                view: '查看车型'
            },
            placeholder: {
                inputVehName: '请输入车型名称',
                inputPassengersNum: '请输入载客人数',
                inputVehNameCN: '请输入车型中文',
                inputVehNameEN: '请输入车型英文',
                inputPickupPrice: '请输入接送机/站售价'
            },
            vehicleType: '用车类型',
            passengersNum: '载客人数',
            vehName: '车型名称',
            vehNameCN: '车型中文名称',
            vehNameEN: '车型英文名称',
            isPickup: '支持接送机/站',
            pickupPrice: '接送机/站售价',
            isReleased: '是否发布',
            versionNo: '版本号',
            vehCode: '车型编码',
            vehIntroduction: '车型简介',
            vehPic: '车型图片',
            vehPicContent: {
                title: '仅支持jpg，png格式文件，单个文件不超过10MB；',
                content: '上传车型图片'
            },
            vehPricelist: '常用时长及费用',
            vehPriceTable: {
                duration: '时长(h)',
                price: '售价'
            },
            vehSupPricelist: '供应商合同报价',
            vehSupPriceTable: {
                supplier: '供应商',
                contractPrice: '合同价',
                overtimeFee: '超时费',
                overKilometerFee: '超公里费'
            },
            vehQtylist: '分配量配置',
            vehQtyTable: {
                dateRange: '用车日期范围',
                date: '日期',
                quantity: '分配量',
                allowance: '余量'
            },
            historicalVersionQuery: '历史版本查询',
            historyVerTable: {
                lastUpdateUser: '修改人',
                lastUpdateDate: '修改日期',
                view: '进入查看'
            }
        },
        errorText: {
            required: '必填',
            typeInteger: '只能输入正整数。',
            maxNumber999: '最大载客人数999。',
            maxBigMin: '最大载客人数必须大于等于最小载客人数。',
            only1to9999999: '只能输入1~9999999的正整数。',
            only1to24: '只能输入1~24的正整数。',
            cannotSame: '不能配置2条相同记录！',
            maxNumber1000: '最多输入1000字',
            bookedNo0cannotDelete: '已预订量不为0, 不能删除。',
            cannotLessThanReservedVolume: '分配量的修改不能低于已预订量',
            onlyJpgPng: '仅支持jpg，png格式文件!',
            onlyByFileFormat: '仅支持{0}格式文件!',
            lessMB: '单个文件不超过{0}MB!',
            notAllowed0: '不允许上传大小是0的文件。',
            limit: '最多上传{0}个附件',
            less10M: '单个文件不超过10MB!',
            time0to100: '开始时间范围 0 - 100',
            greaterThanLowerLimit: '必须要大于下限时间',
            lessThanUpperLimit: '必须要小于上限时间',
            cannotLessNow: '不能小于当前时间',
            startTImeCannotGreaterEnd: '开始时间不能大于结束时间',
            vehicleOnlyOnceTime: '一个用车类型只能有一段用车时间段',
            vehicleOnlyOnceLock: '一个用车类型一种锁只能设置一次',
            bookedLockLessQueuingLock: '同一车型中预订锁时间必须晚于排队锁时间，请重新配置'
        },
        messagebox: {
            confirmDelete: '确定要删除吗？',
            confirmReset: '确定要重置取消规则说明吗？',
            releasedSucess: '发布成功',
            cancelReleasedSucess: '取消发布成功',
            saveAndQuit: '车型信息发生变化，是否保存后退出？',
            quitEdit: '车型信息发生变化，是否放弃编辑？',
            atLeastOne: '分配量配置至少需要有一个有效项',
            deleteCancelRule: '请谨慎删除取消规则！',
            deleteVehicleLock: '请谨慎删除用车锁！',
            deleteSuccess: '删除成功'
        }
    },
    // 财务管理
    financialManagement: {
        financialManagement: '财务管理',
        businessTravelFinance: '商旅财务',
        BM: {
            budgetManagement: '预算管理',
            isEnable: '是否启用预算管理',
            noEnable: '该展会未启用预算管理',
            groupNo: '团组编号',
            applicantName: '申请人',
            applicantDate: '申请日期',
            totalBudget: '预算总额',
            hotelBudget: '酒店预算',
            hotelRoomCharge: '酒店房费',
            hotelNoShow: '酒店Noshow',
            hotelRemaining: '酒店剩余',
            vehicleBudget: '车辆预算',
            vehicleExpense: '车辆费用',
            vehicleNoShow: '车辆Noshow',
            vehicleRemaining: '车辆剩余',
            deptName: '费用部门',
            projectName: '费用项目',
            groupSource: '团组来源',
            addBudget: '新增预算',
            editBudget: '编辑预算',
            sumBudget: '资源预算总计',
            modifyLogs: '修改日志',
            w3Account: '修改人',
            operateDate: '修改日期',
            oldDesc: '修改前信息',
            newDesc: '修改后信息'
        },
        placeholder: {
            groupNo: '请输入团组编号',
            groupNoAndSearch: '请输入团组编号并点击搜索',
            hotelBudget: '请输入酒店预算',
            vehicleBudget: '请输入车辆预算'
        },
        message: {
            saveSuccessed: '保存成功',
            associated: '已有关联订单，无法操作。',
            configBudget: '请配置预算',
            hotelBudget: '酒店预算小于已使用预算{0}，请重新配置',
            vehicleBudget: '车辆预算小于已使用预算{0}，请重新配置',
            sumBudgetReconfig: '酒店预算与车辆预算之和已超出预算总额，请重新配置'
        },
        confirmMsg: {
            deleteOperation: '确认删除已选择的数据吗？',
            cancelOperation: '是否确认取消操作？'
        },
        errorMsg: {
            hasAssociatedOrder: '已有关联订单，无法操作。',
            hasBookedOrder: '该日期下已有预订成功订单，不能删除！',
            plsAddTotalBudget: '预算不足，无法提交订单，请追加总预算!',
            plsContactPM: '预算不足，无法提交订单，请联系项目经理（接待经理）追加预算!',
            plsAddBudget: '预算不足，请调整团组预算!',
            noInMRS: '该团组编号不在MRS系统存在或者未审批通过，请在MRS团组中核对团组信息。',
            configBudget: '请配置预算。',
            onlyNonnegativeNumber: '只能输入非负数，最小0，最大9999999.99。',
            overBudget: '资源预算总计已超出预算总额，请重新配置。',
            groupConfigured: '该团组预算已配置，不可重复新增。',
            hotelBudget: '酒店预算小于已使用预算，请重新配置。',
            vehicleBudget: '车辆预算小于已使用预算，请重新配置。',
            noPermission: '无权限新增该团组预算。',
            cannotDelete: '该预算已有关联订单或Noshow费用支出，无法删除。',
            groupNotExist: '该团组编号不在MRS系统存在或者未审批通过，请在MRS团组中核对团组信息。'
        },
        FS: {
            financialStatements: '财务报表',
            hotel: '酒店',
            vehicle: '车辆',
            inventory: '库存管理表',
            checkin: '酒店实际入住曲线表',
            sale: '酒店销售贡献比例图',
            inventoryTable: {
                date: '日期',
                hotelName: '酒店名称',
                room: '房型',
                groupName: '团组名称',
                export: '导出',
                hotel: '酒店',
                roomStatistics: '房型统计及团组预订',
                roomContractPrice: '房间合同价',
                roomPrice: '房间售价',
                roomTotalQty: '各房型间夜数合计',
                totalContractPrice: '成本',
                totalPrice: '收入',
                totalAmount: '利润'
            }
        }
    },
    // 展会配置国际化
    exhiConfig: {
        plsExhiNameTip: '请输入会场名称',
        delTip: '是否执行该操作？',
        mainSite: '主会场',
        breakoutRoom: '分会场',
        mapLonLat: '地图经纬度',
        baidu: '百度',
        google: '谷歌',
        plsSiteName: '请输入会场名称',
        scrollLockSettings: '滚动锁设置',
        lockType: '锁类型',
        lockDate: '锁定日期',
        effectiveDate: '起效日期',
        effectiveStatus: '生效状态',
        exhiShortName: '展会简称',
        upload1920: '上传资源首页banner1920*500px',
        upload760: '上传展会首页banner760*410px',
        uploadLimitSize: '上传KV图<br/>{0}*{1}px',
        isHotLimit: '已达到推荐上限，不能继续推荐',
        hostDept: '请选择主办部门',
        error: '操作失败',
        success: '操作成功',
        exhiIsSelected: '展会已经被引用',
        allSee: '所有人不可见',
        adminSee: '管理员可见',
        noSee: '不可见',
        editExhi: '编辑展会',
        upload: '上传',
        config: '展会配置',
        reset: '重置',
        exhiName: '展会名称',
        enterExhiName: '请输入展会名称',
        enterExhiDate: '请输入展会时间',
        pleaseComplete: '请完善第',
        Mandatory: '行的必填项',
        modifiedModification: '请确认名单是否修改，如已修改请先保存。',
        exhiDate: '展会时间',
        exhiPlace: '展会地点',
        enterPlace: '请输入地点',
        isShow: '是否可见',
        export: '导出',
        isHot: '推荐展会',
        all: '全部',
        exhiBasicInfo: '展会基本信息',
        exhiNameCN: '展会名称（中文）',
        exhiNameEN: '展会名称（英文）',
        enterExhiNameEN: '请输入展会英文名称',
        checkExhiNameEn: '请勿输入中文字符',
        CIMSName: 'CIMS展会ID',
        MRSName: 'MRS展会ID',
        defaultCurrency: '默认币种名称',
        currencySymbol: '默认币种符号',
        countryName: '国家/地区',
        provinceName: '省/州',
        cityName: '城市',
        baiduLongitude: '百度地图经纬度',
        Longitude: '经度',
        Latitude: '纬度',
        googleLongitude: '谷歌地图经纬度',
        timeZone: '时区',
        enterTimeZone: '请选择时区',
        exhiAdmin: '展会管理员（会展侧）',
        exhiAdminBus: '业务侧管理员',
        deptCode: '主办部门',
        introduction: '展会简介',
        enterIntroduction: '请输入展会简介',
        enterContent: '请输入内容',
        bigPhoto: '展会图片',
        imgTip: '支持jpg,png等格式文件，单个文件不超过10MB',
        exhiType: '展会类型',
        singleGroup: '单体量单团组',
        multiGroup: '综合型多团组',
        selectExhi: '选择展会',
        enterLatitude: '请输入纬度',
        enterLongitude: '请输入经度',
        LatitudeRange: '-90 ~ 90',
        LongitudeRange: '-180 ~ 180',
        dot10: '只能精到小数点后10位',
        rule: '酒店规则',
        importingListRule: '导入名单规则',
        enterRule: '请输入酒店规则',
        max4000: '最大输入4000个字符',
        max150Tip: '最大输入50个汉字或150个英文字母、数字',
        enterAdmin: '请选择展会管理员',
        enterBusAdmin: '请选择业务侧管理员',
        max5: '最多请选择 5 个展会管理员',
        busMax5: '最多请选择 5 个业务侧管理员',
        bizhong: '请选择币种',
        bizhongFuhao: '请输入币种符号',
        enterCountry: '请选择国家/地区',
        enterProvince: '请选择省/州',
        enterCity: '请选择城市',
        enterCityExhi: '请选择城市或填写TBD',
        enterTime: '请选择时区',
        uploadIng: '请上传图片',
        limit1920: '单个文件必须是尺寸1920*500px',
        limitSize: '单个文件不超过{0}MB',
        fail: '上传失败',
        editSucess: '编辑展会成功',
        addSucess: '新增展会成功',
        exhiDetail: '展会详情',
        addExhi: '新增展会',
        roomMax: '预订房间上限',
        custMax: '客户合住上限',
        cancelMin: '取消预订离入住天数范围下限',
        cancelMax: '取消预订离入住天数范围上限',
        fee: '手续费扣费比率（%）',
        enterRoomMax: '请输入预订房间上限',
        roomLimit: '预订房量上限 1-99',
        enterCustMax: '请输入客户合住上限',
        custLimit: '客户合住上限 1-4',
        ruleErr: '酒店规则不正确',
        ruleErr2: '酒店规则不完整',
        rangeLimit: '入住天数范围 0 - 100',
        dayuDown: '上限天数必须要大于下限天数',
        noRepeat: '不能添加同一区间的重复配置信息',
        dayuUp: '下限天数必须要小于上限天数',
        feeLimit: '手续费扣费比率 0 - 100',
        deletSuccess: '删除成功',
        companyFee: '公司付费',
        tripFee: '商旅付费',
        limit760: '单个文件必须是尺寸760*410px',
        imgLimitSize: '单个文件必须是尺寸{0}*{1}px',
        mainExhiVenue: '主会场',
        subExhiVenue: '分会场',
        mapLongLatitude: '地图经纬度',
        enterVenue: '请输入会场名称',
        enterVenu: '请输入会场简称',
        maxLength150: '最大输入50个汉字或150个英文字母、数字',
        notRepeat: '请勿输入相同的会场名称'

    },
    // 火车票、飞机票、休闲资源
    trainTicket: {
        editS: '编辑成功',
        addS: '新增成功',
        placeOfOrigin: '始发地',
        destination: '目的地',
        cheCi: '车次/车型',
        fare: '票价',
        placeOfOriginPY: '始发地(拼音)',
        destinationPY: '目的地(拼音)',
        tripDate: '旅行日期',
        ticketLJ: '火车票资源链接',
        tripIntro: '行程说明',
        planeCom: '航空公司',
        zheKou: '折扣',
        xieYiJia: '协议价',
        planeLJ: '机票资源链接 ',
        planeInfo: '航程说明',
        type: '类型',
        lersureName: '休闲资源名称',
        lersureNameLJ: '休闲资源链接',
        lersureImg: '休闲资源图片',
        limit10: '支持jpg,png等格式文件，单个文件不超过10MB',
        trainZYPZ: '火车票资源配置',
        enterPlaceOfOrigin: '请输入始发地',
        enterDestination: '请输入目的地',
        enterCheCi: '请输入车次/车型',
        planeZYPZ: '机票资源配置',
        leisureZYPZ: '休闲资源配置',
        limitLength300: '最大输入300字节',
        notBeEqual: '目的地和始发地不能相同',
        notBeEqualPY: '目的地(拼音)和始发地(拼音)不能相同',
        enter: '请输入',
        limitLength150: '最大输入150字节',
        limitDot2: '最多两位小数',
        limitLength900: '最大输入900字节',
        limit4000: '最大输入4000字节',
        enterOriginDAXIE: '请输入始发地拼音(大写)',
        enterDestinationDAXIE: '请输入目的地拼音(大写)',
        maxNum10: '只能输入数字范围0 - 10',
        isDelete: '请确认是否删除?',
        tips: '提示',
        leastOne: '请选择一条数据',
        enterPlaneName: '请输入航空公司名称',
        addTrain: '新增火车票',
        editTrain: '编辑火车票',
        lookTrain: '查看火车票详情',
        addPlane: '新增机票',
        editPlane: '编辑机票',
        lookPlane: '查看机票详情',
        addLeisure: '新增休闲资源',
        editLeisure: '编辑休闲资源',
        lookLeisure: '查看休闲资源详情',
        limitWidth368: '单个文件必须是尺寸368*220px',
        dayuling: '不能输入负数',
        URL: '必须以https或者http开头且符合url规范的地址',
        isHot: '是否推荐'
    },
    // 车辆预订配置详情国际化
    byCar: {
        placeholder: '请输入地点查找',
        appOffCar: '已完成送行用车申请',
        appMeetCar: '已完成送行用车申请'
    },
    // 个人中心
    personalCenter: {
        personalTitle: '个人信息', // 1
        editPersonalInfo: '编辑个人信息', // 1
        modifyPassword: '修改密码', // 1
        name: '英文姓/名', // 1
        phone: '手机', // 1
        email: '邮箱', // 1
        landline: '座机', // 1
        nationality: '国籍', // 1
        sex: '性别', // 1
        placeholder: {
            lastName: 'LastName(姓)', // 1
            fristName: 'FristName(名)', // 1
            phoneCode: '区号', // 1
            phone: '电话号码', // 1
            extensionNo: '分机号', // 1
            tel: '请输入手机号',
            area: '请选择归属地'
        },
        commonAddress: {
            edit: '编辑地址',
            add: '新增地址', // 1
            name: '姓名', // 1
            tel: '手机', // 1
            city: '所在地区', // 1
            detailAddress: '详细地址', // 1
            zip: '邮编', // 1
            tip: {
                selectCountryAreaCode: '请选择手机区号',
                inputTel: '请输入正确的手机号',
                inputName: '请输入名称',
                inputPhone: '请输入电话号码',
                inputZip: '请输入邮编'
            }
        }
    },
    // 公司预订酒店详情页面国际化
    detailHotel: {
        copySuccess: '复制成功',
        prompt: '温馨提示：入住和离店最早入住时间：{0}以后 最晚离店时间：{1}以前'
    },
    // 我的导入导出
    myImportExport: {
        title: '我的导入导出',
        dialogTitle: '导入导出信息',
        tipInfo: '请在我的导入导出查看导出导入信息',
        toImportExport: '进入我的导入导出',
        serialNumber: '序号',
        fileName: '文件名称',
        importTab: '我的导入',
        exportTab: '我的导出',
        importStatus: '导入状态',
        exportStatus: '导出状态',
        fileSize: '文件大小',
        operateQty: '导入条数',
        exportQty: '导出条数',
        totalTime: '总耗时'
    },
    // 我的钱包
    myWalletI18n: {
        inNoshow: '含Noshow',
        myWallet: '我的钱包',
        feeType: '费用类型',
        conAmount: '消费金额',
        used: '已使用',
        unused: '未使用',
        contractPrice: '合同单价',
        plsEnterContractPrice: '请输入合同单价',
        frontlinePersonTips: '如需追加酒店预算和车辆预算，请联系项目经理（接待经理）',
        hotelExpenditure: '酒店预算费用支出情况',
        vehicleExpenditure: '车辆预算费用支出情况',
        totalExpenditure: '总预算费用支出情况',
        modifyBudget: '修改预算',
        addTotalBudget: '追加总预算',
        totalRemaining: '总剩余',
        expenseDetails: '费用明细'
    },
    // 订单列表
    orders: {
        phoneCheck: '请输入正确的电话号码',
        gmdzzbyhbj: '该名单正在被{0}编辑，请稍后处理!',
        selectModificationRecords: '请选择2条修改记录进行对比!',
        comparisonOfModifiedRecords: '修改记录比对',
        projectManager: '项目经理',
        importList: '导入名单',
        exportCustomers: '导出客户',
        plsEneterOrderNo: '请输入订单编号',
        keyword: '关键字',
        plsEneterKeyword: '订单编号/团组编号/酒店名称',
        recentOrdersTitle: '近期订单',
        orderNo: '订单编号',
        company: '公司',
        creationDate: '预订日期',
        bookingTravelDate: '入离日期',
        totalAmount: '总金额',
        rooms: '间',
        night: '晚',
        inputSchedDate: '请选择入离日期',
        status: {
            submitted: '已提交',
            waitingConfirm: '待确认',
            confirmed: '已确认',
            cancelled: '已取消',
            waitingPaid: '待支付',
            review: '复核',
            quotaRoomConfirmed: '配额房待确认',
            newSubmission: '新提交'
        }
    },
    // 媒体模块
    media: {
        // 组织模块
        organization: {
            contactPerson: '邀请人',
            creationTime: '创建时间'
        },
        // 申请模块
        application: {
            enterKeywords: '请输入关键字:申请单号/姓名/行业/单位',
            waitApproval: '待审批',
            creator: '创建人',
            batchApproval: '批量审批',
            remark: '备注'
        },
        person: {
            msg: {
                cancelAttendAcknowledge: '请确认是否取消参会?',
                cancelAttendAcknowledgeBeforeEnd: '你确认取消该嘉宾的参会信息？',
                cancelAttendAcknowledgeAfterEnd: '你确认取消参会？取消后对应的座位号就会作废，无法重新注册，如果还需要，请联系管理员，谢谢！'
            }
        }
    },
    switchConfig: {
        resourceNodeSwitch: '资源节点开关',
        personErrorTip: '人员模块下存在订单,不允许关闭'
    },
    registManage: {
        qrcode: '二维码',
        mobileQrcode: '移动端二维码',
        scanQrcode: '扫二维码实名领取',
        registManage: '报名管理',
        registManageConfig: '报名管理配置',
        resourceConfig: '报名资源配置',
        registList: '报名注册名单',
        electronicTicket: '电子票',
        agendaManage: '议程资料管理',
        blacklistManage: '黑名单管理',
        agenda: '议程',
        guest: '嘉宾',
        staff: '员工',
        uploadTip: '注：尽量上传正脸清晰的图片，格式支持5M JPG、PNG、JPEG、BMP.',
        uploadNoCheckTip: '注：格式支持5M JPG、PNG、JPEG、BMP.',
        batchPass: '批量同意',
        batchReject: '批量驳回',
        agendaConfig: '议程配置',
        speakerConfig: '演讲嘉宾配置',
        activeDate: '活动日期',
        agendaSubject: '议题',
        post: '职务',
        speaker: '演讲人',
        speakerPost: '演讲人职务',
        country: '国籍',
        timeInterval: '时段',
        addTimeInterval: '添加时段',
        uploadPic: '上传图片',
        groupConfig: '员工组别配置',
        groupContacter: '组别接口人',
        staffPermConfig: '员工权限配置',
        staffPerm: '员工权限',
        staffPermCN: '员工权限（中文）',
        staffPermEN: '员工权限（英文）',
        permDesc: '权限说明',
        isNeedReview: '是否复核',
        reviewApprover: '复核审批人',
        seatConfig: '座位号配置',
        regionalConfig: '区域配置',
        regional: '区域',
        registEndTime: '报名截止时间',
        registeredScale: '已注册规模',
        ticketClassifyConfig: '票众分类配置',
        audience: '受众',
        audienceNameCN: '受众名称（中文）',
        audienceNameEN: '受众名称（英文）',
        otherConfig: '其他配置',
        smsConfig: '短信配置',
        isCertificateRequired: '证件信息是否必填',
        isCertificateCollect: '证件信息是否收集',
        freezeTime: '取消参会冻结时间',
        permAppraved: '员工权限是否审批',
        ticketDetailDisplay: '票夹详情显示',
        headerImgRequired: '上传图片是否必填',
        headerImgType: '上传图片类型',
        headerImgDesc: '上传图片说明',
        faceOnly1: '人脸（仅上传1张）',
        otherAllow2: '其他（可上传2张）',
        staffPermFreezeTime: '员工权限设置冻结时间',
        approveConfig: '审批配置',
        approveStatus: '审批状态',
        seatNo: '座位号',
        seatNoRegion: '座位号/区域',
        isSupportTransfer: '是否支持转赠',
        transApprover: '转赠审批人',
        groupName: '组别',
        sequence: '顺序',
        scale: '规模',
        groupNameCN: '员工组别(中文)',
        groupNameEN: '员工组别(英文)',
        confirmSend: '确认发送',
        sendEmail: '发送邮件',
        savePicture: '保存图片',
        scanAndDraw: '扫二维码实名领取',
        receiverSeatNo: '接收人-座位号',
        receiverCorporateName: '接收人-公司名称',
        receiverCardNo: '接收人-证件号',
        receiverCardType: '接收人-证件类型',
        cardType: '证件类型',
        receiverPhoneNo: '接收人-联系电话',
        receiver: '接收人',
        transferor: '转赠人',
        transferTime: '转赠时间',
        staffNo: '员工工号',
        staffName: '员工姓名',
        staffName1: '员工姓名:',
        staffCardNo: '员工卡号',
        staffCardNo1: '员工卡号:',
        cardNo: '工作证卡号',
        cardNo1: '工作证卡号:',
        chipNo: '芯片编号:',
        countryRegion: '国籍',
        IDNumber: '证件号码',
        companyName: '公司名称',
        guestRegistManage: '嘉宾报名管理',
        employeeRegistManage: '员工报名管理',
        transferApprovalManage: '转赠审批管理',
        privacyConfig: '隐私配置',
        department: '部门',
        selectSeatNo: '座位号/区域',
        cancelSuccess: '取消成功',
        sureTransPass: '您确定同意转赠申请？',
        transSuccess: '转赠审批成功',
        transFailed: '转赠审批失败',
        sureTransReject: '您确定驳回转赠申请？',
        rejectSuccess: '驳回成功',
        rejectFailed: '驳回失败',
        headerPicLimit5: '头像大小不能超过5M',
        timeoverlap: '时间不能重叠',
        startEndTimeErr: '开始时间须小于结束时间',
        endStartTimeErr: '结束时间须大于开始时间',
        batchSave: '批量保存',
        require: '请完善必填项！',
        sendEmailSuccess: '邮件发送成功！',
        sendEmailFailed: '邮件发送失败！',
        tipOneRow: '请至少选择1条记录！',
        fill4Number: '请输入完整4位数字',
        fillTime: '输入时间',
        isRegisted: '是否已注册',
        grantPerms: '授予分配的权限',
        isAllocated: '是否已分配',
        isDivided: '是否已分票',
        keyword: '关键词',
        invalid: '作废',
        audienceVote: '受众分票',
        ticketAgent: '票务接口人',
        attendStatus: '参会状态',
        sendMeetingInfo: '发送参会信息',
        checkInStatus: '签到状态',
        entryStatus: '入场状态',
        submitter: '提交人',
        submitTime: '提交时间',
        staffPermSetting: '员工权限设置',
        seatSearchholder: '请输入关键字（座位号/接口人）进行查询',
        guestSearchholder: '请输入关键字（姓名/座位号/区域/公司名称）进行查询',
        staffSearchholder: '请输入关键字（姓名/员工账号）进行查询',
        staffPermSettingSucc: '员工权限设置成功',
        sendAttendMsgSucc: '参会消息发送成功',
        approved: '通过',
        staffNo1: '员工编号',
        staffInfo: '员工信息',
        currentHandler: '当前处理人',
        processInfo: '流程信息',
        staffRegistApprove: '员工报名审批电子流',
        seatNoinformation: '座位号信息',
        guestRegistInfo: '嘉宾报名信息',
        staffRegistInfo: '员工报名信息',
        approveDetail: '审批详情',
        isnotify: '领证是否通知',
        nosign: '未签到',
        signed: '已签到',
        noentry: '未入场',
        entryed: '已入场',
        checkIn: '签到',
        checkInSuccess: '签到成功',
        placeholderfill: '请填写...',
        placeholderselect: '请选择...',
        approver: '权限审批人',
        transConfigTitle: '转赠审批配置',
        guestConfigTitle: '嘉宾相关配置',
        staffConfigTitle: '员工相关配置',
        entryTypeCfg: '入场方式配置',
        addImage: '添加图片',
        isReject: '是否驳回',
        isConfirmApprove: '是否确认批量同意？',
        isRejectApprove: '是否确认批量驳回？',
        isConfirmPermissionApprove: '您勾选的员工都会赋予当前选择的权限，您确定审批通过？',
        setPermConfirmTips: '您勾选的员工都会赋予当前选择的权限，是否确定？',
        exceedingApprovalDeadline: '账号{0}超出审批截止时间！',
        sendAttendMsg: '发送参会消息',
        msgContent: '发送内容',
        sendType: '发送方式',
        sendTo: '发送到',
        sendTime: '定时发送时间',
        sender: '发送人',
        sendingTime: '发送时间',
        sendingStatus: '发送状态',
        sendingStatus0: '未发送',
        sendingStatus1: '发送成功',
        sendingStatus2: '发送失败',
        delSeatConfirm: '确定作废座位号吗？',
        recoverSeatConfirm: '你确定恢复该座位号吗？',
        delRegistedSeatConfirm: '选中项包含已注册或已作废座位号，无法作废！',
        delRegistedRegionConfirm: '当前展会该区域已录入信息，无法删除！',
        delRegistedPermConfirm: '当前展会该权限已录入员工信息，无法删除！',
        empPermDead: '员工权限设置已冻结',
        empPermApproving: '{0} 员工权限待审批，不可重复设置！',
        seatregionalsearch: '座位号/区域搜索',
        seatsearch: '座位号搜索',
        staffAccount: '员工账号',
        companyDept: '公司-职责',
        phoneRequired: '手机号不可为空',
        setDeadline: '设置冻结时间',
        systemDeadline: '系统冻结时间',
        deadlinetips: '注：冻结时间后只有管理员可以操作',
        certificateNumber: '身份证号',
        neetFaceReco: '是否需要人脸识别',
        privacyPolicyConfig: '隐私政策配置',
        showPrivacyPolicy: '是否显示爱上会政策',
        privacyPolicyUrl: '隐私政策链接',
        errTipPrivacyPolicyUrl: '请输入隐私政策链接',
        recover: '恢复',
        groupQrcode: '组别注册二维码',
        transCard: '工作证转让',
        idCardErr: '请输入正确的身份证号码！',
        noHandleWidthVoid: '状态为已作废时，不能进行此操作！',
        recoverWidthVoid: '仅状态为已作废时可以恢复，请重新选择！',
        recoverSuccess: '恢复成功！',
        recoverFailed: '恢复失败！',
        phoneErrTip: '手机号长度为11位数字',
        noPermOnRejectCancel: '参会状态为驳回或取消参会时，不能进行此操作！',
        sameSeatCannotRecover: '有相同座位号时，不能进行恢复！',
        batchDownloadImg: '批量下载图片',
        transSuccess1: '转让成功！',
        transFailed1: '转让失败！',
        deleteObsoleteDelete: '仅可以删除已作废数据，请重新选择！',
        deleteConfirm: '确定删除座位号吗？',
        sendLogTitle: '发送日志',
        restrictedAge: '是否限制注册年龄',
        ageLimits: '年龄限制',
        ageTips: '年龄提示内容',
        policeValidate: '是否启用公安接口校验',
        guestExportTips: '您导出的文件会涉及到隐私信息，请确定是有需要才导出文件？如若需要导出，文件请加密才可以能进行传输，请知悉！',
        statistic: '统计',
        seatsNumber: '座位数',
        registeredNumber: '已注册数',
        admissionsNumber: '已入场数',
        blacklistConfig: '黑名单清单配置',
        blacklistRegister: '黑名单注册信息',
        licensePlateNumber: '车牌号',
        licensePlateNumberErrorTip: '请输入正确的车牌号!',
        delBlacklistConfigConfirm: '您确认删除勾选的黑名单清单？',
        remarkErrorTip: '最大输入1000个汉字或3000个英文字母、数字',
        blacklistConfigSaveSuccess: '配置成功',
        blacklistConfigSaveFailed: '配置失败',
        blacklistConfigUpdateSuccess: '更新配置成功',
        blacklistConfigUpdateFailed: '更新配置失败',
        blacklistRegisterAccount: '注册账号',
        blacklistRegisterDate: '注册时间',
        employeePermissionDescription: '员工权限说明:',
        permissions: '权限',
        isHuaweiEmployee: '是否为华为员工',
        chipNumber: '卡号/编号',
        employeeGroup: '员工组别',
        scaleNumber: '规模数',
        approvedNumber: '已审批通过数',
        acheckInNumber: '已签到数',
        enteredNum: '已入场数',
        importDialogTitle: '导入信息查看',
        importDescLine: '第{0}行',
        isExhiAdminVisible: '仅限展会管理员可见',
        empSmsConfig: '员工短信配置',
        isRegisterSms: '审批通过后自动触发注册成功短信',
        registerSmsContent: '短信内容',
        isCertificateSms: '自动触发领证短信',
        certificateSmsDate: '设置发送时间',
        certificateSmsContent: '短信内容',
        empPermissionDeadline: '员工权限截止时间',
        community: '社区',
        reviewStatus: '复核权限状态',
        approvalLog: '审批日志',
        approvalNode: '审批状态',
        approvalTime: '审批时间',
        approvalOpinion: '审批意见'
    }
}
